import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import "../styles/chart.css";

const ChartComponent = ({ dataKeys }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const fetchDataAndCreateChart = async () => {
      const response = await fetch('/db2/hist.json');
      const data = await response.json();

      const datasets = dataKeys.map((dataKey, index) => {
        const dataArray = data[dataKey];
        const values = dataArray;

        // Set different color for the second value in the array
        const borderColor = index === 1 ? 'red' : 'blue';

        return {
          label: dataKey,
          data: values,
          borderColor,
          backgroundColor: 'rgba(0, 0, 255, 0.1)',
        };
      });

      const labels = Array.from({ length: datasets[0].data.length }, (_, i) => i + 1);

      const ctx = chartRef.current.getContext('2d');

      if (chartInstance.current) {
        // If chartInstance exists, destroy the previous chart
        chartInstance.current.destroy();
      }

      // // Get the container's dimensions
      // const container = chartRef.current.parentElement;
      // const containerWidth = container.clientWidth;
      // const containerHeight = container.clientHeight;

      // // Set canvas dimensions to match the container
      // chartRef.current.width = "1200px";
      // chartRef.current.height = "500px";

      // Create the new chart with animation disabled
      chartInstance.current = new Chart(ctx, {
        type: 'line',
        data: {
          labels,
          datasets,
        },
        options: {
          animation: false, // Disable animation
        },
      });
    };

    fetchDataAndCreateChart();
  }, [dataKeys]);

  return (
    <div className="chart-container">
      <canvas ref={chartRef} id="chart"/>
    </div>
  );
};

export default ChartComponent;
